import React, {useState, useEffect} from 'react'

import classes from './PopupCatalogue.module.css'
import Popup from '@/components/shared/Popup/Popup';
import Catalogue from '@/js/Catalogue/Catalogue';
import CatalogueListItem from './CatalogueListItem/CatalogueListItem';
import CatalogueItem from './CatalogueItem/CatalogueItem';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Texts from 'react-sdk/Texts';
import { FaHandPointLeft } from 'react-icons/fa6';

const PopupCatalogue = () => {


  let opened = PopupsManager.getData(POPUPS.CATALOGUE)

  const [selectedItem, setSelectedItem] = useState(opened);

  const showLegend = Catalogue.roots.some(item => item.knowledge !== 0)

  return (
    <Popup className={classes.PopupCatalogue} onClose={() => PopupsManager.close(POPUPS.CATALOGUE)}>
      <div className={classes.PopupCatalogueContent}>
        <div className={classes.sidebar}>
          {showLegend &&
          <div className={classes.legend}>
            <div className={classes.maitrise}>
              {Texts.get("catalogue-maitrise")}
              <div  className={classes.tooltip}
              dangerouslySetInnerHTML={{__html: Texts.get("catalogue-maitrise-tooltip")}} />

            </div>
            <div className={classes.non_maitrise}>
              {Texts.get("catalogue-non-maitrise")}
              <div  className={classes.tooltip}
              dangerouslySetInnerHTML={{__html: Texts.get("catalogue-non-maitrise-tooltip")}} />
            </div>
          </div>}

          {Catalogue.roots.map(item => {
            if(item.locked) return null

            return (
            <CatalogueListItem key={item.id} item={item} onClick={(_item) => setSelectedItem(_item)} selected={selectedItem?.id === item.id} >

              {item.Children.length > 0 &&
              <div className={classes.children}>
                {item.Children
                .filter(child => !child.locked)
                .map(child => <CatalogueListItem selected={selectedItem?.id === child.id} item={child} onClick={(_item) => setSelectedItem(_item)} />)}
              </div>}
            </CatalogueListItem>)
          })}
        </div>

        <div className={classes.content}>
          {selectedItem && <CatalogueItem item={selectedItem} />}
          {!selectedItem &&
          <div className={classes.click_incitation}>
            <div className={classes.hand_icon}>
              <FaHandPointLeft />
            </div>
            <div className={classes.click_incitation_text} dangerouslySetInnerHTML={{__html: Texts.get("catalogue-click-incitation")}} />
          </div>}
        </div>


      </div>


    </Popup>
  );
};

export default PopupCatalogue;
